module.exports = __webpack_public_path__ + "static/media/logo.8100b7fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/logo.jpg
// module id = 74
// module chunks = 0